import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import { SessionProvider, useSession } from "./auth";
import { StoreProvider } from "./store";
import { Gate } from "./views/Gate";
import "./theme.css";

/* The session resolves before the portfolio is fetched, not alongside it.
   Every /api call the store makes needs an active account, so loading them in
   parallel would just produce a screenful of 401s behind the sign-in screen. */
function Root() {
  const session = useSession();
  if (session.status !== "in") return <Gate session={session} />;
  return (
    <StoreProvider>
      <App />
    </StoreProvider>
  );
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <SessionProvider>
      <Root />
    </SessionProvider>
  </StrictMode>,
);
